import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Card from "./Card"; // make sure the path is correct

const responsive = {
  superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 6 },
  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
  tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
  mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
};

// Custom left arrow
const CustomLeftArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      background: "goldenrod",
      color: "black",
      border: "none",
      borderRadius: "50%",
      width: "45px",
      height: "45px",
      cursor: "pointer",
      fontSize: "22px",
      zIndex: 2,
      boxShadow: "0 2px 6px rgba(0,0,0,0.4)",
    }}
  >
    ‹
  </button>
);

// Custom right arrow
const CustomRightArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    style={{
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      background: "goldenrod",
      color: "black",
      border: "none",
      borderRadius: "50%",
      width: "45px",
      height: "45px",
      cursor: "pointer",
      fontSize: "22px",
      zIndex: 2,
      boxShadow: "0 2px 6px rgba(0,0,0,0.4)",
    }}
  >
    ›
  </button>
);

const TheCarousel = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div style={{ position: "relative" }}>
      <Carousel
  responsive={responsive}
  infinite
  keyBoardControl
  swipeable={true}       // allow swipe on touch
  draggable={true}       // allow mouse drag
  showDots={false}
  customLeftArrow={<CustomLeftArrow />}
  customRightArrow={<CustomRightArrow />}
  removeArrowOnDeviceType={[]} // ← keep arrows on all devices
  containerClass="carousel-container"
  itemClass="carousel-item"
>
  {items.map((item) => (
    <div key={item.id}>
      <Card item={item} />
    </div>
  ))}
</Carousel>
    </div>
  );
};

export default TheCarousel;
